import {
    FETCHED_PAGES,
    FETCHED_PAGES_TYPES,
    DELETED_PAGE,
    SELECTED_PAGE_TYPE,
    SELECTED_PAGE_TAGS_DESTINATION,
    SELECTED_PAGE_TAGS_CONTINENT,
    SELECTED_PAGE_TAGS_TRIP_FORMAT,
    SELECTED_PAGE_TAGS_TYPE_OF_WORK,
    SELECTED_PAGE_TAGS_TYPE_OF_WORK_TAG,
    SELECTED_PAGE_TAGS_TYPE_OF_WORK_GROUP,
    SELECTED_PAGE_TAGS_ALL,
    CLOSE_ADD_PAGE_POPUP,
    FETCHED_PAGES_TAGS_BY_PAGE_TYPE,
    SELECT_STATUS_CODE,
    UPDATE_REDIRECT_URL,
    CLEAR_REDIRECT_URL,
    CLEAR_STATUS_CODE,
    HAS_ERROR,
    PUBLISHED_PAGE,
    UNPUBLISHED_PAGE,
    UPDATE_TRANSLATION_SITE,
    CLEAR_TRANSLATION_SITE,
    FETCHED_EXISTING_PAGE_TRANSLATIONS,
    FETCHED_MISSING_PAGE_TRANSLATIONS,
    UPDATE_ADD_TRANSLATION_SITES,
    CLEAR_ADD_TRANSLATION_SITES,
    SELECT_ALL_ADD_TRANSLATION_SITES
} from './types';
import update from 'immutability-helper/index';

const INITIAL_STATE = {
    all: [],
    types: [],
    selectedPageType: '',
    tagsByPageType: [],
    selectedPageTagsDestination: [],
    selectedPageTagsContinent: [],
    selectedPageTagsTripFormat: [],
    selectedPageTagsTypeOfWork: [],
    selectedPageTagsTypeOfWorkTag: [],
    selectedPageTagsTypeOfWorkGroup: [],
    selectedPageTagsAll: [],
    selectedStatus: [],
    redirectUrl: '',
    existingPageTranslations: [],
    missingPageTranslations: [],
    selectedSite: null,
    selectedSites: [],
    error: {}
};

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {

        case FETCHED_PAGES:
        
            return update(state, {
                all: {$set: action.payload.data},
                selectedPageType: {$set: ''},
                selectedPageTagsDestination: {$set: []},
                selectedPageTagsContinent: {$set: []},
                selectedPageTagsTripFormat: {$set: []},
                selectedPageTagsTypeOfWork: {$set: []},
                selectedPageTagsTypeOfWorkTag: {$set: []},
                selectedPageTagsTypeOfWorkGroup: {$set: []},
                selectedPageTagsAll: {$set: []},
            });

        case FETCHED_PAGES_TYPES:

            return update(state, {
                types: {$set: action.pageTypes},
            });

        case DELETED_PAGE:

            let allPages = state.all.filter(item => item.id !== action.pageId);

            return update(state, {
                all: {$set: allPages}
            });

        case SELECTED_PAGE_TYPE:

            return update(state, {
                selectedPageType: {$set: action.selectedPageType},
                selectedPageTagsDestination: {$set: []},
                selectedPageTagsContinent: {$set: []},
                selectedPageTagsTripFormat: {$set: []},
                selectedPageTagsTypeOfWork: {$set: []},
                selectedPageTagsTypeOfWorkTag: {$set: []},
                selectedPageTagsTypeOfWorkGroup: {$set: []},
                selectedPageTagsAll: {$set: []},
            });

        case FETCHED_PAGES_TAGS_BY_PAGE_TYPE:

            return update(state, {
                tagsByPageType: {$set: action.tagsByPageType},
            });

        case SELECTED_PAGE_TAGS_DESTINATION:
    
            return update(state, {
                selectedPageTagsDestination: {$set: action.selectedTags}
            });
        
        case SELECTED_PAGE_TAGS_CONTINENT:
    
            return update(state, {
                selectedPageTagsContinent: {$set: action.selectedTags}
            });
        
        case SELECTED_PAGE_TAGS_TRIP_FORMAT:
    
            return update(state, {
                selectedPageTagsTripFormat: {$set: action.selectedTags}
            });
        
        case SELECTED_PAGE_TAGS_TYPE_OF_WORK:
    
            return update(state, {
                selectedPageTagsTypeOfWork: {$set: action.selectedTags}
            });
        
        case SELECTED_PAGE_TAGS_TYPE_OF_WORK_TAG:
    
            return update(state, {
                selectedPageTagsTypeOfWorkTag: {$set: action.selectedTags}
            });
        
        case SELECTED_PAGE_TAGS_TYPE_OF_WORK_GROUP:
    
            return update(state, {
                selectedPageTagsTypeOfWorkGroup: {$set: action.selectedTags}
            });
        
        case SELECTED_PAGE_TAGS_ALL:
    
            return update(state, {
                selectedPageTagsAll: {$set: action.selectedTags}
            });

        case CLOSE_ADD_PAGE_POPUP:

            return update(state, {
                selectedPageType: {$set: ''},
                selectedPageTagsDestination: {$set: []},
                selectedPageTagsContinent: {$set: []},
                selectedPageTagsTripFormat: {$set: []},
                selectedPageTagsTypeOfWork: {$set: []},
                selectedPageTagsTypeOfWorkTag: {$set: []},
                selectedPageTagsTypeOfWorkGroup: {$set: []},
                selectedPageTagsAll: {$set: []},
            });

        case SELECT_STATUS_CODE:
    
            return update(state, {
                selectedStatus: {$set: action.selectedStatus}
            });

        case UPDATE_REDIRECT_URL:
    
            return update(state, {
                redirectUrl: {$set: action.redirectUrl}
            });

        case CLEAR_REDIRECT_URL:
    
            return update(state, {
                redirectUrl: {$set: ''}
            });

        case CLEAR_STATUS_CODE:
    
            return update(state, {
                selectedStatus: {$set: []}
            });

        case HAS_ERROR:

            return update(state, {
                error: {$merge: {
                    [action.payload.field]: action.payload.metaError
                }}
            });

        case PUBLISHED_PAGE:

            let indexPublishedPage = state.all.findIndex(item => item.id === action.pageId);

            return update(state, {all : {
                [indexPublishedPage] : {$merge: {published: 1}}
            }});

        case UNPUBLISHED_PAGE:

            let indexUnpublishedPage = state.all.findIndex(item => item.id === action.pageId);

            return update(state, {all : {
                [indexUnpublishedPage] : {$merge: {published: 0}}
            }});

        case FETCHED_EXISTING_PAGE_TRANSLATIONS:

            return update(state, {
                existingPageTranslations: {$set: action.existingPageTranslations},
            });

        case UPDATE_TRANSLATION_SITE:
    
            return update(state, {
                selectedSite: {$set: action.selectedSite}
            });

        case CLEAR_TRANSLATION_SITE:
    
            return update(state, {
                selectedSite: {$set: []}
            });
    
        case FETCHED_MISSING_PAGE_TRANSLATIONS:
        
            let sites = action.payload.missingPageTranslations;
        
            sites = sites.map(site => {
                site.is_checked = false;
                return site;
            });
        
            return update(state, {
                missingPageTranslations: {$set: sites}
            });
    
        case UPDATE_ADD_TRANSLATION_SITES:
        
            let updatedSiteId = action.payload.updatedSite;
            updatedSiteId = parseInt(updatedSiteId, 10);
        
            let updatedSites = state.missingPageTranslations;
        
            let updatedSiteIndex = updatedSites.findIndex(item => item.id === updatedSiteId);
        
            let isChecked = updatedSites[updatedSiteIndex]["is_checked"];
        
            return update(state, {
                missingPageTranslations: {[updatedSiteIndex]: {$merge: {is_checked: !isChecked}}}
            });
    
        case SELECT_ALL_ADD_TRANSLATION_SITES:
        
            let updatedMissingPageTranslations = state.missingPageTranslations;
    
            updatedMissingPageTranslations = updatedMissingPageTranslations.map((item) => {
                if (!item.has_translation) {
                    item.is_checked = true;
                }
                return item;
            });
        
            return update(state, {
                missingPageTranslations: {$set: updatedMissingPageTranslations}
            });
    
        case CLEAR_ADD_TRANSLATION_SITES:
        
            return update(state, {
                selectedSites: {$set: []}
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/pages/reducer.js